import React from 'react';
import { PTStepIndicator } from './PTStepIndicator';

import s from './index.module.scss';

const StepIndicator = ({ currentStep, steps, onChange }) => (
  <div className={s['step-indicator']}>
    {steps.map((item) => (
      <div
        className={`${s['step-indicator__step']} ${item.completed ? s['step-indicator__step--completed'] : ''} ${
          item.name === currentStep.name ? s['step-indicator__step-current'] : ''
        }`}
        onClick={item.clickable ? () => onChange(item) : null}
        onKeyDown={item.clickable ? () => onChange(item) : null}
        style={{ cursor: `${item.clickable ? 'pointer' : 'default'}` }}
        key={`step-${item.name}`}
      >
        <div className={s['step-indicator__step-name']}>
          {item.completed && (
            <img
              src="/static/icons/checkmark.svg"
              alt={`${item.name} completed icon`}
              className={s['step-indicator__icon-completed']}
              width={18}
              height={13}
            />
          )}
          <span>{item.name}</span>
        </div>
        {(item.completed || item.name === currentStep.name) && (
          <svg
            className={s['step-indicator__icon-arrow']}
            viewBox="0 0 2 2"
            preserveAspectRatio="none"
          >
            <polygon points="0,0 2,1 0,2" />
          </svg>
        )}
      </div>
    ))}
  </div>
);

StepIndicator.propTypes = PTStepIndicator;

export default StepIndicator;
